import { Box } from "@bca/ui-library";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";

const GradientBox = styled(Box)<PositionProps>`
  ${position};
  background-image: linear-gradient(transparent, transparent, #070b16);
`;

export default GradientBox;
